<script>
import GenericResourcesView from "@/components/GenericResourcesView";
import { useResourcesStore } from "../../stores/resources";
import bus from "../../bus";

export default {
  setup() {
    const resourcesStore = useResourcesStore();
    return {
      resourcesStore,
    };
  },

  components: {
    GenericResourcesView,
  },

  data() {
    return {
      buttons: [
        {
          id: "download",
          label: "components.grid.download_button",
          color: "airbnbBlue",
        },
      ],
    };
  },
  created() {
    bus.on("download", this.download);
  },
  methods: {
    async download({ id }) {
      this.resourcesStore.adminDownloadTownFile({ import_data_id: id });
    },
  },
};
</script>

<template>
  <div>
    <GenericResourcesView
      class="p-5"
      type="imports"
      :header="$t('views.admin.import_historic')"
      :buttons="buttons"
    />
  </div>
</template>
